import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { SENTRY_DNS } from '../../config';

const initSentry = () => {
  if (import.meta.env.MODE === 'production') {
    Sentry.init({
      dsn: SENTRY_DNS,
      environment: import.meta.env.MODE,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV6Instrumentation(
            useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
          ),
        }),
      ],
      tracesSampleRate: 1.0,
    });
  }
};

export {
  initSentry,
};
